import { JSX, FC, useState, useEffect } from "react";
import { LngLat, Popup, PopupEvent } from "react-map-gl/mapbox";
import { ProviderFootprintFeatureProperties } from "@app/overviews/market-expansion-dashboard/shared/ProviderFootprintFeatureProperties";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";

interface ProviderFootprintPopupProps {
  keepOpen?: boolean;
  popupPosition?: LngLat;
  onClose?: (e: PopupEvent) => void;
  providerFeatures: ProviderFootprintFeatureProperties[];
}

const ProviderFootprintPopup: FC<ProviderFootprintPopupProps> = ({
  keepOpen = false,
  popupPosition,
  onClose,
  providerFeatures,
}): JSX.Element => {
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  useEffect(() => {
    setCurrentIndex(0);
  }, [providerFeatures]);

  const provider = providerFeatures[currentIndex] ?? providerFeatures[0];

  const longitude = popupPosition?.lng ?? provider.longitude;
  const latitude = popupPosition?.lat ?? provider.latitude;

  return (
    <Popup
      closeOnClick={false}
      closeButton={keepOpen}
      onClose={onClose}
      latitude={latitude}
      longitude={longitude}
      maxWidth="24rem"
    >
      <div className="provider-footprint__provider-details-popup" data-testid="provider-footprint__provider-details-popup">
        <strong className={keepOpen ? "popup-close-button-padding" : ""}>
          {provider.facilityName}
        </strong>
        <em>{provider.contractEntityName}</em>
        <span>Total Cases: {provider.serviceAreaCases ? provider.serviceAreaCases.toLocaleString() : "---"}</span>

        {providerFeatures.length > 1 && (
          <div className="provider-pagination">
            {keepOpen &&
              <button
                className="provider-pagination-btn"
                onClick={() => setCurrentIndex((i) => i - 1)}
                disabled={currentIndex <= 0}
                data-testid="market-expansion__provider-footprint-popup__prev-btn"
              >
                <QesIcon iconName={QesIcons.ChevronLeft} description="Previous provider" />
              </button>
            }
            <span className="provider-pagination-label">
              <i>{currentIndex + 1} of {providerFeatures.length}</i>
            </span>
            {keepOpen &&
              <button
                className="provider-pagination-btn"
                onClick={() => setCurrentIndex((i) => i + 1)}
                disabled={currentIndex >= providerFeatures.length - 1}
                data-testid="market-expansion__provider-footprint-popup__next-btn"
              >
                <QesIcon iconName={QesIcons.ChevronRight} description="Next provider" />
              </button>
            }
          </div>
        )}
      </div>
    </Popup>
  );
};

export default ProviderFootprintPopup;
